import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { AttributeValue, AttributeValueListResponse, AttributeValueQueryParams, CreateAttributeValue } from '@frontend/attribute/types';

export class AttributeValueClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchAttributeValues(queryParams?: ApiQueryParams<AttributeValueQueryParams>): Promise<AttributeValueListResponse> {
        return await this.apiPaginated<AttributeValueListResponse, AttributeValueQueryParams>(`${this.endpoint}/attribute-values`, queryParams);
    }

    public static async resolveAttributeValues(ids: string[], field: string = 'id'): Promise<AttributeValueListResponse> {
        return this.resolve<AttributeValueListResponse>(`${this.endpoint}/attribute-values`, ids, field);
    }

    public static async deleteAttributeValues(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/attribute-values-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postAttributeValue(accountId: string, attributeId: string, body: CreateAttributeValue): Promise<AttributeValue> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}/attribute-values`, body);
        return await this.handleResponse(response);
    }

    public static async fetchAttributeValue(accountId: string, attributeId: string, attributeValueId: string): Promise<AttributeValue> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}/attribute-values/${attributeValueId}`);
        return await this.handleResponse(response);
    }

    public static async patchAttributeValue(
        accountId: string,
        attributeId: string,
        attributeValueId: string,
        body: CreateAttributeValue
    ): Promise<AttributeValue> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}/attribute-values/${attributeValueId}`, body);
        return await this.handleResponse(response);
    }

    public static async deleteAttributeValue(accountId: string, attributeId: string, attributeValueId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}/attribute-values/${attributeValueId}`);
        return await this.handleVoidResponse(response);
    }
}
